import apiUrls from '../constants/urls'
import axios from 'axios'

export default {
  getClassTypes () {
    const url = apiUrls.backEnd.classTypes
    return axios.get(url)
  },
  search (payload) {
    const url = apiUrls.backEnd.search
    return axios.post(url, payload, { timeout: 2 * 60 * 1000 })
  },
  flightDetails (itinerary) {
    const url = apiUrls.backEnd.flightDetails
    // console.log('SJISJI flightDetails SERVICE itinerary', itinerary)
    return axios.put(url, itinerary)
  },
  flightFinalDetails (itinerary) {
    const url = apiUrls.backEnd.flightFinalDetails
    // console.log('SJISJI flightFinalDetails SERVICE itinerary', itinerary)

    // clean itinerary
    // delete itinerary.detail_fare_rules
    // delete itinerary.detail_more_info
    delete itinerary.for_revalidate
    delete itinerary.light_request
    delete itinerary.key_fare_rules
    delete itinerary.luggage_options_params

    // console.log('SJISJI flightFinalDetails SERVICE itinerary', itinerary)
    return axios.put(url, itinerary)
  },
  bookingCreate (data) {
    const url = apiUrls.backEnd.bookingCreate
    return axios.post(url, data)
  },
  ferrySend (jsonData) {
    const url = apiUrls.backEnd.ferrySendAISC
    return axios.post(url, jsonData)
  },
  /**
   * Call the back end to put an option on the selected itinerary
   * @param customer {Object}
   * @param travellers {Object}
   * @param accessToken {string}
   * @param luggageOptionsPerTrip {Object}
   * @param bookingIdentifier {string}
   * @param detailFareRules {Array}
   * @return {Promise} axios always return a promise
   */
  bookingSendAISC ({
    customer,
    travellers,
    luggageOptionsPerTrip,
    accessToken,
    bookingIdentifier,
    detailFareRules
  }) {
    const data = {
      customer,
      travellers,
      luggageOptionsPerTrip,
      bookingIdentifier,
      detailFareRules
    }
    const url = apiUrls.backEnd.bookingSendAISC
    return axios.post(url, data)
  },
  sendErrorToAmplitudes ({
    customer,
    travellers,
    luggageOptionsPerTrip,
    errorMsg,
    manualMsg,
    bookingIdentifier,
    selectedItinerary
  }) {
    const data = {
      customer,
      travellers,
      luggageOptionsPerTrip,
      bookingIdentifier,
      selectedItinerary,
      errorMsg,
      manualMsg
    }
    console.log('sendErrorToAmplitudes', data)
    const url = apiUrls.backEnd.errorSendAISC
    return axios.post(url, data)
  }
}
